module.exports = __webpack_public_path__ + "assets/802f2cb82e3fafc90096a62a73e1dd2a.svg";